module.exports = __webpack_public_path__ + "static/media/21-4.04ed9fef.mp3";